import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../../icon';
import getContentColor from '../../__utils/contrastChecker';
import GroupIcon from './group-icon';
import OrgIcon from './org-icon';
import UserIcon from './user-icon';

import './style.scss';

const Avatar = ({
  type,
  size,
  imageUrl,
  text,
  sport,
  primaryColor,
  secondaryColor,
  showOuterBorder,
  onMouseEnter,
  onMouseLeave,
  onClick,
  className,
  qaId,
}) => {
  let backgroundColor;
  let borderColor;
  let contentColor;

  if (!imageUrl && (text || sport)) {
    // If there is a primary color provided, use it for the background.
    // Otherwise, use the default provided by the CSS.
    if (primaryColor) {
      backgroundColor = primaryColor.indexOf(',') === -1 ? '#' + primaryColor : primaryColor;
    }

    // Use the secondaryColor if present, otherwise use default provided by the CSS.
    if (secondaryColor) {
      borderColor = secondaryColor.indexOf(',') === -1 ? '#' + secondaryColor : secondaryColor;
    }

    // Do some contrast checking and provide a color
    contentColor = getContentColor(primaryColor, secondaryColor);
  }

  const avatarClasses = classNames('uni-avatar', {
    'uni-avatar--has-click': onClick,
    [`uni-avatar--${size}`]: size,
    'uni-avatar--has-outer-border': showOuterBorder,
    [className]: className,
  });

  const avatarTextClasses = classNames('uni-avatar__initials', {
    [`uni-avatar__initials--${type}`]: type,
  });

  // 1. Image wins out over everything
  // 2. Otherwise we just show text with the colors determined above
  // 3. No text? Show the default avatar icon
  let avatarContents;
  if (imageUrl) {
    avatarContents = (
      <div className="uni-avatar__img-container">
        <img className="uni-avatar__img" src={imageUrl} loading="lazy" />
      </div>
    );
  } else if (text) {
    avatarContents = (
      <div
        className="uni-avatar__content-container"
        style={{ backgroundColor: backgroundColor, borderColor: borderColor }}
      >
        <h5 className={avatarTextClasses} style={{ color: contentColor }}>
          {text}
        </h5>
      </div>
    );
  } else {
    if (type === 'group') {
      avatarContents = (
        <div className="uni-avatar__content-container" style={{ backgroundColor: '#45515E', borderColor: borderColor }}>
          <GroupIcon />
        </div>
      );
    } else if (type === 'org') {
      avatarContents = (
        <div className="uni-avatar__content-container" style={{ backgroundColor: '#45515E', borderColor: borderColor }}>
          <OrgIcon />
        </div>
      );
    } else if (type === 'team') {
      const sportIcon = sport ? sport : 'othersport';
      avatarContents = (
        <div
          className="uni-avatar__content-container"
          style={{ backgroundColor: backgroundColor, borderColor: borderColor }}
        >
          <Icon type={sportIcon} className="uni-avatar__icon" style={{ color: contentColor }} />
        </div>
      );
    } else {
      avatarContents = (
        <div className="uni-avatar__content-container" style={{ backgroundColor: '#45515E', borderColor: borderColor }}>
          <UserIcon />
        </div>
      );
    }
  }

  return (
    <div
      className={avatarClasses}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      data-qa-id={qaId}
    >
      {avatarContents}
    </div>
  );
};

Avatar.propTypes = {
  type: PropTypes.string,
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'profile']),
  imageUrl: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sport: PropTypes.string,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  showOuterBorder: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  className: PropTypes.string,
  qaId: PropTypes.string,
};

Avatar.defaultProps = {
  size: 'medium',
  className: '',
};

export default Avatar;



// WEBPACK FOOTER //
// ./src/avatars/__partials/avatar.jsx